import React from "react";
import { Tabs } from "antd";

const TabUi = ({ tabId, setTabId }) => {
    return (
      <Tabs
        className="mx-2 text-base"
        popupClassName="mb-0"
        tabBarStyle={{
          marginBottom: 0,
        }}
        activeKey={tabId}
        defaultActiveKey={tabId}
        items={[
          { label: "Products", key: "products" },
          { label: "Mass import", key: "mass_import" },
          { label: "Suppliers management", key: "suppliers_management" },
          { label: "Non-Publishable Keywords", key: "non_publishable_keywords" },
          { label: "Brand mappings", key: "brand_mappings" },
        ]}
        onChange={(value) => {
          setTabId(value);
        }}
      />
    );
  };

export default TabUi;